export const strings = {
    tr: {
        meta: {
            home: {
                title: "Mona Klinik | Kadıköy'de İmplant ve Estetik Diş Tedavisi Merkezi",
                description: "Kadıköy'ün merkezinde ulaşım kolaylığı olan Mona Klinik'te implant, ortodonti, estetik diş hekimliği ve kanal tedavisi hizmetleri. 20 yıllık deneyimli kadromuzla gülüşünüzü tasarlıyoruz."
            },
            about: {
                title: "Hakkımızda | 20 Yıllık Deneyimli Diş Kliniği | Mona Klinik",
                description: "20 yıllık deneyimli, uzman kadromuzla Kadıköy'de hizmet veren Mona Klinik'in hikayesi. Modern teknoloji ve hasta odaklı yaklaşımı keşfedin. Konforlu tedavi bizim önceliğimiz."
            },
            services: {
                title: "Ağız ve Diş Sağlığı Hizmetleri | İmplant, Ortodonti | Mona Klinik",
                description: "Mona Klinik'te implant, ortodonti, protez, kanal tedavisi ve diğer ağız-diş tedavileri. En son teknoloji ekipmanlarla, uzman kadromuzla kalıcı çözümler sunuyoruz."
            },
            blog: {
                title: "Diş Sağlığı Blog | Uzman Önerileri ve Tedavi Bilgileri | Mona Klinik",
                description: "Ağız ve diş sağlığınız için uzman hekimlerimizden öneriler, tedavi yöntemleri, bakım ipuçları ve merak ettikleriniz. Her yaşa uygun diş sağlığı bilgileri."
            },
            contact: {
                title: "İletişim | Kadıköy'de Diş Kliniği | Mona Klinik",
                description: "Mona Klinik ile hemen iletişime geçin. Kadıköy Osmanağa'daki kliniğimize kolay ulaşım, online randevu ve WhatsApp hattımız ile 7/24 ulaşılabilirlik. +90 0532 294 40 05"
            }
        },
        altText: {
            logo: "Mona Klinik Kadıköy diş kliniği logosu",
            banner: "Mona Klinik Kadıköy'deki modern diş kliniği iç mekan görünümü ve steril tedavi ortamı",
            doctor: "Dr. Samet Aksu - Kadıköy'de 20 yıllık deneyimli diş hekimi",
            doctorExamination: "Dr. Samet Aksu implant tedavisi öncesi hasta muayenesi yaparken",
            gallery: "Mona Klinik gülüş tasarımı tedavisi öncesi ve sonrası hasta fotoğrafı",
            blog: "Diş sağlığı ve implant teknolojileri hakkında bilgilendirici blog görseli",
            testimonial: "Mona Klinik'te tedavi gören memnun hasta yorumu ve değerlendirmesi",
            service: "Mona Klinik'te sunulan implant ve estetik diş tedavisi hizmeti görseli",
            icon: "Diş tedavisi ve hizmet kategorisini temsil eden özel tasarım ikon",
            shape: "Mona Klinik web sitesi dekoratif şekil elementi",
            pattern: "Mona Klinik kurumsal kimlik dekoratif desen elementi",
            trFlag: "Türkçe dil seçeneği - Türkçe içeriğe geçiş için bayrak ikonu",
            enFlag: "İngilizce dil seçeneği - English content için bayrak ikonu",
            call: "Mona Klinik +90 0532 294 40 05 telefon iletişim bilgisi ikonu"
        },
        navbar: {
            home: "Ana Sayfa",
            about: "Hakkımızda",
            services: "Hizmetlerimiz",
            blog: "Blog",
            contact: "İletişim",
            appointmentButton: "Randevu Al",
            doctorTitle: "Diş Hekimi"
        },
        banner: {
            title: "Gülüşünüzü Uzmanlara Emanet Edin",
            description: "Kadıköy'ün merkezinde, Moda'ya yürüme mesafesinde bulunan kliniğimizde, en son tedavi teknolojilerini kullanarak değerli hastalarımızın güvenini kazanıyor ve endişelerinizi gideriyoruz. 20 yıllık deneyimimiz ve uzman kadromuzla, sorunlarınıza kalıcı ve ekonomik çözümler sunuyoruz.",
            workingHours: "Çalışma Saatleri: 09:00 - 23:00",
            doctorName: "Dr. Samet Aksu",
            doctorTitle: "Diş Hekimi"
        },
        services: {
            sectionTitle: "HİZMETLERİMİZ",
            mainTitle: "Ağız ve Diş Sağlığında Güvenilir Çözüm",
            description: "Mona Klinik olarak Kadıköy'deki modern kliniğimizde, siz değerli hastalarımızın güvenini kazanmak, kaygılarınızı ortadan kaldırmak için en güncel tedavi teknolojilerini kullanıyoruz. 20 yıllık tecrübemiz ve uzman kadromuzla, sorunlarınıza kalıcı ve ekonomik çözümler sunuyoruz.",
            viewAll: "Tüm Hizmetlerimizi İnceleyin",
            items: [
                {
                    title: "Protez",
                    description: "Eksik dişlerinizi, doğal görünümlü ve konforlu protezlerle tamamlıyoruz."
                },
                {
                    title: "İmplant",
                    description: "Kalıcı ve sağlıklı çözümler için ileri implant teknolojileri kullanıyoruz."
                },
                {
                    title: "Beyazlatma",
                    description: "Profesyonel diş beyazlatma ile daha parlak ve güzel bir gülüşe kavuşun."
                },
                {
                    title: "Kanal Tedavisi",
                    description: "Ağrısız ve konforlu kanal tedavisi ile dişlerinizi kurtarıyoruz."
                }
            ]
        },
        emergency: {
            sectionTitle: "KALİTELİ HİZMET",
            title: "Nazik ve güler yüzlü yaklaşımla diş tedavisi",
            description: "Mona Klinik olarak siz değerli hastalarımızı güler yüzle karşılıyor, samimi bir ortamda ağırlıyoruz. Her hastamızı ailemizin bir parçası olarak görüyor, tedavi sürecinde maksimum konfor sağlıyoruz. Deneyimli ekibimiz ve içten yaklaşımımızla, size özel çözümler sunuyoruz.",
            appointmentButton: "Randevu Al"
        },
        features: {
            sectionTitle: "ÖZELLİKLERİMİZ",
            title: "Uzman kadromuzla özel hizmet",
            description: "20 yıllık deneyimimiz ve güler yüzlü ekibimizle, siz değerli hastalarımıza en iyi hizmeti sunuyoruz.",
            items: [
                {
                    title: "Önce Güvenlik",
                    description: "Sterilizasyon ve hijyen konusunda en üst düzey önlemler"
                },
                {
                    title: "Kurumsal Hizmetler",
                    description: "Şirketlere ve kurumlara özel avantajlı tedavi planları"
                },
                {
                    title: "Tam Donanımlı Klinik",
                    description: "Tüm diş tedavilerini tek çatı altında uyguluyoruz"
                },
                {
                    title: "Güler Yüzlü Yaklaşım",
                    description: "Her yaştan hastamızı anlayışla karşılıyoruz"
                }
            ]
        },
        expert: {
            sectionTitle: "UZMAN DİŞ HEKİMLERİ",
            title: "İstanbul'un deneyimli diş hekimlerinden uzman tedavi",
            description: "Mona Klinik'te her hasta özeldir. Modern diş hekimliğinin tüm imkanlarını kullanarak, konforlu ve kaliteli tedavi hizmeti sunuyoruz.",
            benefits: [
                "Uzman ve deneyimli diş hekimi kadrosu",
                "Son teknoloji dental ekipmanlar",
                "Hasta odaklı tedavi yaklaşımı"
            ]
        },
        testimonial: {
            sectionTitle: "HASTA YORUMLARI",
            title: "Hastalarımız hakkımızda ne diyor?",
            description: "Tedavi sürecinde ve sonrasında hastalarımızdan aldığımız değerli geri bildirimler en büyük motivasyon kaynağımızdır. Her hastamızın memnuniyeti ve güzel gülüşü, işimizi doğru yaptığımızın en güzel kanıtıdır.",
            comments: [
                {
                    name: "Coşkun Namlı",
                    comment: "İmplant tedavisi için Mona Klinik'i tercih ettim. Dr. Samet ve ekibi son derece profesyonel ve ilgili. Tedavi sürecim çok rahat geçti ve sonuçlardan çok memnunum.",
                    rating: 5
                },
                {
                    name: "Fethi Bayram",
                    comment: "Diş beyazlatma için gittiğim klinikte Dr. Samet'in uzmanlığı ve güler yüzlü yaklaşımı sayesinde harika sonuçlar aldım. Gülüşümdeki değişim inanılmaz!",
                    rating: 5
                },
                {
                    name: "Ayça Çevik Özkan",
                    comment: "Estetik dolgu işlemi için tercih ettiğim Mona Klinik'te modern teknoloji ve uzman kadro sayesinde çok başarılı bir tedavi süreci geçirdim. Doğal görünümlü dolgularım için teşekkürler.",
                    rating: 5
                }
            ]
        },
        appointment: {
            sectionTitle: "RANDEVU AL",
            title: "Gülüşünüzü Güzelleştirmek İçin Buradayız",
            description: "Modern teknolojiler ve uzman kadromuzla, konforlu ve kaliteli tedavi hizmeti sunuyoruz. Randevu almak için formu doldurun veya bizi arayın.",
            form: {
                email: {
                    label: "E-POSTA ADRESİ",
                    placeholder: "E-posta adresinizi giriniz..."
                },
                service: {
                    label: "TEDAVİ",
                    placeholder: "Tedavi seçiniz"
                },
                phone: {
                    label: "TELEFON NUMARASI",
                    placeholder: "Telefon numaranızı giriniz..."
                },
                message: {
                    label: "MESAJINIZ",
                    placeholder: "Mesajınızı giriniz..."
                },
                button: "Randevu Talebi Gönder",
                success: "Randevu talebiniz başarıyla gönderildi. En kısa sürede sizinle iletişime geçeceğiz.",
                error: "Randevu talebiniz gönderilirken bir hata oluştu. Lütfen daha sonra tekrar deneyin veya bizi telefonla arayın.",
                sending: "Gönderiliyor...",
                validation: {
                    emailRequired: "E-posta alanı zorunludur",
                    emailInvalid: "Geçerli bir e-posta adresi giriniz",
                    serviceRequired: "Tedavi seçimi zorunludur",
                    phoneRequired: "Telefon numarası zorunludur",
                    phoneInvalid: "Geçerli bir telefon numarası giriniz",
                    contactRequired: "E-posta adresi veya telefon numarasından en az birini girmelisiniz"
                }
            },
            contact: {
                title: "Mona Diş Kliniği",
                phone: "+90 0532 294 40 05",
                address: "Kadıköy, Osmanağa Mah. Nal Sk. NO: 11",
                mapUrl: "https://maps.app.goo.gl/N64gtxGnon7XpRBc8"
            }
        },
        footer: {
            description: "Mona Klinik olarak Kadıköy'ün merkezi konumunda, modern teknoloji ve uzman kadromuzla, estetik, koruyucu ve restoratif diş hekimliği hizmetleri sunuyoruz.",
            followUs: "Bizi takip edin",
            quickLinks: "Hızlı Bağlantılar",
            links: {
                aboutUs: "Hakkımızda",
                services: "Servisler",
                dentist: "Doktorlar",
                faqs: "SSS"
            },
            contact: {
                title: "İletişim & Bilgi",
                phone: {
                    title: "Telefon Numarası",
                    value: "+90 0532 294 40 05"
                },
                hours: {
                    title: "Çalışma Saatleri",
                    value: "09:00 - 23:00"
                },
                address: {
                    title: "Adres",
                    value: "Kadıköy, Osmanağa Mah. Nal Sk. NO: 11"
                }
            },
            socialMedia: {
                instagram: "https://www.instagram.com/mona.klinik/"
            }
        },
        about: {
            sectionTitle: "HAKKIMIZDA",
            title: "Modern Diş Hekimliğinde 20 Yıllık Deneyim",
            description: "Ağız ve diş sağlığınızla ilgili kendinizi harika hissetmenizi istiyoruz. Sadece yılda iki kez değil, her ısırıkta, her gülümsemede ve her öpücükte.",
            features: [
                {
                    title: "Uzman Kadro",
                    description: "Alanında uzman diş hekimleri ve deneyimli sağlık personeli"
                },
                {
                    title: "Modern Teknoloji",
                    description: "En son teknoloji dental ekipmanlar ve steril ortam"
                },
                {
                    title: "Hasta Odaklı Yaklaşım",
                    description: "Her hastaya özel tedavi planlaması ve maksimum konfor"
                }
            ]
        },
        priority: {
            sectionTitle: "ÖNCELİĞİMİZ",
            title: "Hastalarımız bizim önceliğimizdir",
            description: "Mona Klinik olarak, her hastamızın tedavi sürecini özenle planlıyor ve takip ediyoruz. Modern teknolojimiz ve uzman kadromuzla, sizlere en kaliteli hizmeti sunmak için çalışıyoruz.",
            button: "Randevu Al"
        },
        safety: {
            sectionTitle: "GÜVENLİK",
            title: "Önce güvenlik gelir",
            description: "Mona Klinik olarak, sterilizasyon ve hijyen konusunda en üst düzey önlemleri alıyoruz. Modern cihazlarımız ve deneyimli ekibimizle, sizlere güvenli bir tedavi ortamı sunuyoruz. Tüm ekipmanlarımız düzenli olarak sterilize edilmekte ve uluslararası standartlara uygun şekilde kullanılmaktadır."
        },
        team: {
            sectionTitle: "EKİBİMİZLE TANIŞIN",
            title: "Diş hekimlerimizle tanışın",
            description: "Mona Klinik'te her biri alanında uzman, deneyimli ve güler yüzlü diş hekimlerimizle tanışın.",
            sideDescription: "Modern diş hekimliğinin tüm imkanlarını kullanarak sizlere en iyi hizmeti sunuyoruz.",
            doctors: [
                {
                    name: "Samet Aksu",
                    title: "Diş Hekimi",
                    description: "İmplantoloji / Diş Hastalıkları ve Tedavisi"
                },
                {
                    name: "Ennur Ecem Aydın",
                    title: "Diş Hekimi",
                    description: "Diş Eti Hastalıkları ve Cerrahisi"
                },
                {
                    name: "Eylül Karasoy",
                    title: "Diş Hekimi",
                    description: "Diş Hastalıkları ve Tedavisi"
                },
                {
                    name: "Gizem Kiraz",
                    title: "Diş Hekimi",
                    description: "Ağız Diş Çene Cerrahisi / Diş Hastalıkları Tedavisi"
                }
            ]
        },
        faq: {
            sectionTitle: "SSS",
            title: "Sıkça sorulan sorular",
            questions: [
                {
                    question: "Diş tedavisi öncesi konsültasyon ücretli mi?",
                    answer: "Mona Klinik'te ilk muayene ve konsültasyon ücretsizdir. Tedavi planlaması ve maliyet bilgilendirmesi için randevu alabilirsiniz."
                },
                {
                    question: "Kadıköy'de park yeri var mı?",
                    answer: "Kliniğimiz Kadıköy merkezde, toplu taşımaya yakın bir konumda yer almaktadır. Yakın çevremizde ücretli otoparklar mevcuttur."
                },
                {
                    question: "Acil diş tedavisi için ne yapmalıyım?",
                    answer: "Acil durumlarda bizi +90 0532 294 40 05 numaralı telefondan arayabilirsiniz. Çalışma saatlerimiz içinde en kısa sürede müdahale etmeye çalışıyoruz."
                },
                {
                    question: "Diş tedavisi sırasında ağrı hisseder miyim?",
                    answer: "Modern diş hekimliğinde kullanılan lokal anestezi yöntemleri sayesinde tedavileriniz ağrısız bir şekilde gerçekleştirilmektedir. Kliniğimizde hasta konforunu en üst düzeyde tutarak, kaygılarınızı minimuma indirmeyi hedefliyoruz."
                }
            ]
        },
        contact: {
            sectionTitle: "İLETİŞİM",
            title: "Bizimle İletişime Geçin",
            description: "Randevu almak veya bilgi edinmek için bizi arayabilir, mail gönderebilir veya iletişim formunu doldurabilirsiniz. İletişim bilgilerinizi bırakın, uzman ekibimiz en kısa sürede size ulaşsın.",
            form: {
                name: "İsim Soyisim",
                email: "E-posta Adresi",
                phone: "Telefon Numarası",
                message: "Mesajınız",
                button: "Gönder"
            }
        },
        smileDesign: {
            title: "Gülüş Tasarımı",
            description: "Konuşurken ve özellikle gülerken dişlerimiz ön planda olur. Dişlerin yüz ile uyumlu ve daha estetik görünmesi, gülüş tasarımı uygulamaları ile mümkündür. Dudaklar, diş eti, dişler ve yüzün birbiri ile uyumu kişiye özel bir gülüş sağlar.",
            button: "Randevu Al"
        },
        dentalSymptoms: {
            sectionTitle: "SEMPTOMLAR",
            title: "Diş Hekimine Başvurmanız Gereken Durumlar",
            description: "Ağız ve diş sağlığınız için erken teşhis çok önemlidir. Bu belirtilerden herhangi birini fark ettiğinizde vakit kaybetmeden diş hekiminize başvurmalısınız.",
            symptoms: [
                {
                    icon: "tooth-pain",
                    title: "Diş Ağrısı",
                    description: "Yemek yerken veya spontane gelişen diş ağrıları"
                },
                {
                    icon: "gum",
                    title: "Diş Eti Kanaması",
                    description: "Diş fırçalarken veya kendiliğinden oluşan kanamalar"
                },
                {
                    icon: "cavity",
                    title: "Çürük Şüphesi",
                    description: "Dişlerde görülen siyah veya kahverengi lekeler"
                },
                {
                    icon: "bad-breath",
                    title: "Ağız Kokusu",
                    description: "Sürekli devam eden ve giderilemeyen ağız kokusu"
                },
                {
                    icon: "sensitivity",
                    title: "Aşırı Hassasiyet",
                    description: "Soğuk veya sıcak yiyecek-içeceklerde oluşan hassasiyet"
                }
            ]
        },
        gallery: {
            sectionTitle: "GALERİ",
            title: "Tedavi Öncesi ve Sonrası",
            description: "Kliniğimizde gerçekleştirdiğimiz başarılı tedavilerden bazı örnekler. Her hasta için özel olarak planlanan tedavilerimizle, doğal ve estetik sonuçlar elde ediyoruz."
        },
        blogs: {
            sectionTitle: "BLOG",
            title: "Haberler & Makaleler",
            description: "Ağız ve diş sağlığı ile ilgili güncel blog yazılarımız, haberler ve sağlıklı önerilerimizi takip edin.",
            viewAll: "Tümünü Gör",
            single: {
                getUpdates: "Sizi Arayalım",
                subscribe: {
                    placeholder: "Telefon numaranızı girin",
                    button: "Beni Ara"
                },
                categories: {
                    title: "Kategoriler"
                },
                category: "Kategori"
            },
            backToBlogs: "Tüm Bloglara Dön",
            noBlogsFound: "Blog bulunamadı"
        },
        cookies: {
            title: "Çerez Bildirimi",
            description: "Bu web sitesi, size en iyi deneyimi sunmak için çerezleri kullanmaktadır. Sitemizi kullanmaya devam ederek, çerez kullanım politikamızı kabul etmiş olursunuz.",
            accept: "Kabul Et",
            reject: "Reddet",
            single: {
                category: "TEKNOLOJİ",
                getUpdates: "Güncel Bilgileri Alın",
                subscribe: {
                    placeholder: "E-posta adresiniz",
                    button: "Abone Ol"
                },
                categories: {
                    title: "Kategoriler",
                    items: [
                        "Teknoloji",
                        "Kanal Tedavisi",
                        "Dişler",
                        "Beyazlatma",
                        "Protez"
                    ]
                },
                technology: {
                    title: "Diş Operasyonlarında Yeni Teknolojiler",
                    content: [
                        "Son yıllarda diş hekimliği alanında önemli teknolojik gelişmeler yaşanıyor ve bu gelişmeler sayesinde tedaviler daha verimli, hassas ve hasta dostu hale geliyor. Geleneksel diş tedavi yöntemlerini dönüştüren bu yenilikler, hasta bakım kalitesini önemli ölçüde artırıyor. İşte diş operasyonlarında kullanılan en yeni teknolojiler:",
                        {
                            subtitle: "1. İntraoral Tarayıcılar ve Dijital Ölçüler",
                            text: "Geleneksel diş ölçüleri çoğu zaman rahatsız edici olabilir ve bazen tam olarak istenilen sonucu vermez. İntraoral tarayıcılar bu sorunu ortadan kaldırarak, ağız içinin ayrıntılı dijital görüntülerini yakalar. Bu tarayıcılar, ışık kaynakları ve sensörler kullanarak dişlerin ve yumuşak dokuların 3D modellerini oluşturur. Böylece diş protezleri daha hassas bir şekilde tasarlanabilir ve hastalar için daha konforlu hale gelir."
                        },
                        // ... diğer içerik bölümleri
                    ]
                }
            },
            cards: [
                {
                    category: "TEKNOLOJİ",
                    title: "Yeni Teknoloji ile Dental Operasyonlar",
                    description: "Modern diş hekimliğinde kullanılan...",
                    img: "../../assets/blog/1.png",
                    url: "yeni-teknoloji-dental-operasyonlar",
                    date: {
                        day: "23",
                        month: "Oca"
                    }
                },
                {
                    category: "DİŞ SAĞLIĞI",
                    title: "Düzenli Diş Bakımı ile Daha Parlak Gülüşler",
                    description: "Düzenli diş bakımının önemi ve evde uygulayabileceğiniz etkili diş bakım yöntemleri.",
                    date: {
                        day: "23",
                        month: "Oca"
                    }
                },
                {
                    category: "HİJYEN",
                    title: "Her Yaş İçin Diş Hijyeni Rehberi",
                    description: "Çocuktan yetişkine her yaş grubu için özel diş bakımı ve hijyen önerileri.",
                    date: {
                        day: "23",
                        month: "Oca"
                    }
                }
            ]
        },
        hero: {
            title: "Gülüşünüzü Uzmanlara Emanet Edin",
            description: "Modern diş hekimliği teknikleri ve uzman kadromuzla, size özel tedavi planlaması yapıyor, gülüşünüzü tasarlıyoruz. Konforlu ve steril ortamımızda, en son teknoloji ile hizmet veriyoruz.",
            appointmentButton: "Randevu Al",
            workingHoursTitle: "Çalışma Saatleri",
            workingHours: "Pazartesi - Cumartesi: 09:00 - 23:00",
            doctorTitle: "Diş Hekimi"
        },
        pagination: {
            previous: "Önceki",
            next: "Sonraki"
        },
        treatmentSidebar: {
            callUs: "Sizi Arayalım",
            callDescription: "Diş probleminiz hakkında konuşmak ister misiniz?",
            phonePlaceholder: "Telefon Numaranız",
            callButton: "Beni Ara",
            sent: "✓ Gönderildi",
            invalidPhone: "Lütfen sadece rakam kullanarak telefon numaranızı girin.",
            successMessage: "Talebiniz alındı! En kısa sürede sizi arayacağız.",
            appointmentButton: "Randevu Al"
        }
    },
    en: {
        meta: {
            home: {
                title: "Mona Clinic | Premium Dental Services in Kadıköy, Istanbul",
                description: "Experience top dental care in Istanbul's vibrant Kadıköy district. Specialized in dental tourism with English-speaking staff, offering implants, cosmetic dentistry, and quality treatments at competitive prices."
            },
            about: {
                title: "About Us | Expert Dental Team with 20 Years Experience | Mona Clinic",
                description: "Discover Mona Clinic's 20-year journey in Kadıköy, Istanbul. Our international team of dentists combines Turkish hospitality with cutting-edge dental technology for foreign patients and local residents alike."
            },
            services: {
                title: "Dental Services | Implants, Cosmetic Dentistry in Istanbul | Mona Clinic",
                description: "Complete dental solutions in Istanbul including implants, veneers, whitening, and emergency treatments for international patients. State-of-the-art equipment and multilingual staff for your comfort."
            },
            blog: {
                title: "Dental Health Blog | Expert Tips for International Patients | Mona Clinic",
                description: "Expert dental insights for international patients visiting Istanbul. Tips on dental tourism in Turkey, treatment options, aftercare advice, and maintaining oral health while traveling."
            },
            contact: {
                title: "Contact Us | Dental Clinic in Kadıköy, Istanbul | Mona Clinic",
                description: "Easily reach Mona Clinic in Kadıköy, Istanbul. Just 30 minutes from the airport with convenient transportation options. Book your consultation online or call +90 0532 294 40 05 for immediate assistance."
            }
        },
        altText: {
            logo: "Mona Clinic - Dental clinic in Kadıköy, Istanbul logo",
            banner: "Mona Clinic modern dental facility interior view with sterile treatment environment",
            doctor: "Dr. Samet Aksu - Experienced dentist with 20 years of practice in Istanbul",
            doctorExamination: "Dr. Samet Aksu examining patient before dental implant procedure",
            gallery: "Mona Clinic smile design before and after treatment patient photo showcasing results",
            blog: "Informative blog image about dental health and implant technologies",
            testimonial: "Satisfied patient testimonial and review from Mona Clinic dental treatments",
            service: "Dental implant and cosmetic dentistry service image from Mona Clinic Istanbul",
            icon: "Custom designed icon representing dental treatment and service category",
            shape: "Mona Clinic website decorative shape element",
            pattern: "Mona Clinic brand identity decorative pattern element",
            trFlag: "Turkish language option - Flag icon for switching to Turkish content",
            enFlag: "English language option - Flag icon for English content",
            call: "Mona Clinic +90 0532 294 40 05 phone contact information icon"
        },
        navbar: {
            home: "Home",
            about: "About Us",
            services: "Services",
            blog: "Blog",
            contact: "Contact",
            appointmentButton: "Book Appointment",
            doctorTitle: "Dentist"
        },
        banner: {
            title: "Trust Your Smile to Professionals",
            description: "At Mona Clinic, located in Kadıköy, we use the latest treatment technologies to gain the trust of our valued patients and eliminate your concerns. With our 20 years of experience and expert staff, we offer permanent and economical solutions to your problems.",
            workingHours: "Working Hours: 09:00 - 23:00",
            doctorName: "Dr. Samet Aksu",
            doctorTitle: "Dentist"
        },
        services: {
            sectionTitle: "OUR SERVICES",
            mainTitle: "Trusted Solution in Dental Health",
            description: "At Mona Clinic, located in Kadıköy, we use the latest treatment technologies to gain the trust of our valued patients and eliminate your concerns. With our 20 years of experience and expert staff, we offer permanent and economical solutions to your problems.",
            viewAll: "View All Services",
            items: [
                {
                    title: "Dentures",
                    description: "We complete your missing teeth with natural-looking and comfortable dentures."
                },
                {
                    title: "Implants",
                    description: "We use advanced implant technologies for permanent and healthy solutions."
                },
                {
                    title: "Whitening",
                    description: "Get a brighter and more beautiful smile with professional teeth whitening."
                },
                {
                    title: "Root Canal",
                    description: "We save your teeth with painless and comfortable root canal treatment."
                }
            ]
        },
        emergency: {
            sectionTitle: "QUALITY SERVICE",
            title: "Gentle, friendly treatment approach",
            description: "At Mona Clinic, we welcome our valued patients with a warm smile and host them in a friendly environment. We see each patient as part of our family and provide maximum comfort during treatment. With our experienced team and sincere approach, we offer personalized solutions for you.",
            appointmentButton: "Book an appointment"
        },
        features: {
            sectionTitle: "FEATURES",
            title: "Specialized care through experiences",
            description: "With our 20 years of experience and friendly team, we provide the best service to our valued patients.",
            items: [
                {
                    title: "Safety First",
                    description: "Highest level precautions in sterilization and hygiene"
                },
                {
                    title: "Corporate Services",
                    description: "Advantageous treatment plans for companies and institutions"
                },
                {
                    title: "Full-Service Dentistry",
                    description: "All dental treatments under one roof"
                },
                {
                    title: "Friendly Approach",
                    description: "We welcome patients of all ages with understanding"
                }
            ]
        },
        expert: {
            sectionTitle: "EXPERTS IN DENTAL",
            title: "Expert treatment from Istanbul's experienced dentists",
            description: "Every patient is special at Mona Clinic. Using all the possibilities of modern dentistry, we provide comfortable and quality treatment service.",
            benefits: [
                "Expert and experienced dentist team",
                "Latest technology dental equipment",
                "Patient-oriented treatment approach"
            ]
        },
        testimonial: {
            sectionTitle: "TESTIMONIAL",
            title: "What people have said about us",
            description: "The valuable feedback we receive from our patients during and after the treatment process is our biggest source of motivation. Every patient's satisfaction and beautiful smile is the best proof that we are doing our job right.",
            comments: [
                {
                    name: "Coşkun Namlı",
                    comment: "I chose Mona Clinic for implant treatment. Dr. Samet and his team are extremely professional and caring. My treatment process was very comfortable, and I am very satisfied with the results.",
                    rating: 5
                },
                {
                    name: "Fethi Bayram",
                    comment: "Thanks to Dr. Samet's expertise and friendly approach at the clinic where I went for teeth whitening, I got amazing results. The change in my smile is incredible!",
                    rating: 5
                },
                {
                    name: "Ayça Çevik Özkan",
                    comment: "At Mona Clinic, which I preferred for my aesthetic filling procedure, I had a very successful treatment process thanks to modern technology and expert staff. Thank you for my natural-looking fillings.",
                    rating: 5
                }
            ]
        },
        appointment: {
            sectionTitle: "BOOK APPOINTMENT",
            title: "We Are Here to Enhance Your Smile",
            description: "We provide comfortable and quality treatment services with modern technologies and our expert staff. Fill out the form to make an appointment or call us.",
            form: {
                email: {
                    label: "EMAIL ADDRESS",
                    placeholder: "Enter your email address..."
                },
                service: {
                    label: "TREATMENT",
                    placeholder: "Select treatment"
                },
                phone: {
                    label: "PHONE NUMBER",
                    placeholder: "Enter your phone number..."
                },
                message: {
                    label: "YOUR MESSAGE",
                    placeholder: "Enter your message..."
                },
                button: "Send Appointment Request",
                success: "Your appointment request has been successfully sent. We will contact you as soon as possible.",
                error: "An error occurred while sending your appointment request. Please try again later or call us by phone.",
                sending: "Sending...",
                validation: {
                    emailRequired: "Email field is required",
                    emailInvalid: "Please enter a valid email address",
                    serviceRequired: "Treatment selection is required",
                    phoneRequired: "Phone number is required",
                    phoneInvalid: "Please enter a valid phone number",
                    contactRequired: "Please provide either email or phone"
                }
            },
            contact: {
                title: "Mona Dental Clinic",
                phone: "+90 0532 294 40 05",
                address: "Kadıköy, Osmanağa Mah. Nal Sk. NO: 11",
                mapUrl: "https://maps.app.goo.gl/N64gtxGnon7XpRBc8"
            }
        },
        footer: {
            description: "At Mona Clinic in Kadıköy, we provide aesthetic, preventive, and restorative dental services with our modern technology and expert staff.",
            followUs: "Follow us on",
            quickLinks: "Quick Links",
            links: {
                aboutUs: "About Us",
                services: "Services",
                dentist: "Doctors",
                faqs: "FAQ"
            },
            contact: {
                title: "Contact & Information",
                phone: {
                    title: "Phone Number",
                    value: "+90 0532 294 40 05"
                },
                hours: {
                    title: "Open Hours",
                    value: "09:00 - 23:00"
                },
                address: {
                    title: "Address",
                    value: "Kadıköy, Osmanağa Mah. Nal Sk. NO: 11"
                }
            },
            socialMedia: {
                instagram: "https://www.instagram.com/mona.klinik/"
            }
        },
        about: {
            sectionTitle: "ABOUT US",
            title: "20 Years of Experience in Modern Dentistry",
            description: "We want you to feel amazing about your oral wellness. Not just twice a year, but every time you take a bite, tell a joke, laugh, or share a kiss.",
            features: [
                {
                    title: "Expert Staff",
                    description: "Specialist dentists and experienced healthcare personnel"
                },
                {
                    title: "Modern Technology",
                    description: "Latest technology dental equipment and sterile environment"
                },
                {
                    title: "Patient-Oriented Approach",
                    description: "Personalized treatment planning and maximum comfort for each patient"
                }
            ]
        },
        priority: {
            sectionTitle: "OUR PRIORITY",
            title: "Our clients are our priority",
            description: "At Mona Clinic, we carefully plan and follow up on each patient's treatment process. With our modern technology and expert staff, we work to provide you with the highest quality service.",
            button: "Book an appointment"
        },
        safety: {
            sectionTitle: "SAFETY",
            title: "We put the safety first",
            description: "At Mona Clinic, we take the highest level of precautions in sterilization and hygiene. With our modern devices and experienced team, we provide you with a safe treatment environment. All our equipment is regularly sterilized and used in accordance with international standards."
        },
        team: {
            sectionTitle: "MEET OUR TEAM",
            title: "Get to know the Mona Clinic dental Team",
            description: "Meet our expert, experienced and friendly dentists at Mona Clinic. Using all the possibilities of modern dentistry, we provide you with the best service.",
            sideDescription: "Modern dentistry's full potential is harnessed to provide you with the best service.",
            doctors: [
                {
                    name: "Samet Aksu",
                    title: "Dentist",
                    description: "Implantology / Dental Diseases and Treatment"
                },
                {
                    name: "Ennur Ecem Aydın",
                    title: "Dentist",
                    description: "Periodontal Diseases and Surgery"
                },
                {
                    name: "Eylül Karasoy",
                    title: "Dentist",
                    description: "Endodontics"
                },
                {
                    name: "Gizem Kiraz",
                    title: "Dentist",
                    description: "Pedodontics"
                }
            ]
        },
        faq: {
            sectionTitle: "FAQ",
            title: "Frequently asked questions",
            questions: [
                {
                    question: "Is there a fee for dental consultation?",
                    answer: "Initial examination and consultation are free at Mona Clinic. You can make an appointment for treatment planning and cost information."
                },
                {
                    question: "Is there parking in Kadıköy?",
                    answer: "Our clinic is located in central Kadıköy, close to public transportation. There are paid parking lots in our immediate vicinity."
                },
                {
                    question: "What should I do for emergency dental treatment?",
                    answer: "In emergencies, you can call us at +90 0532 294 40 05. We try to intervene as soon as possible during our working hours."
                },
                {
                    question: "Will I feel pain during dental treatment?",
                    answer: "Thanks to local anesthesia methods used in modern dentistry, your treatments are performed painlessly. In our clinic, we aim to minimize your concerns by keeping patient comfort at the highest level."
                }
            ]
        },
        contact: {
            sectionTitle: "CONTACT",
            title: "Contact Us",
            description: "You can call us, send an email, or fill out the contact form to make an appointment or get information. Leave your contact details and our expert team will reach you as soon as possible.",
            form: {
                name: "Full Name",
                email: "Email Address",
                phone: "Phone Number",
                message: "Your Message",
                button: "Send"
            }
        },
        smileDesign: {
            title: "Smile Design",
            description: "Our teeth are prominent when speaking and especially when smiling. Having teeth that are harmonious with the face and more aesthetic appearance is possible with smile design applications. The harmony of lips, gums, teeth, and face provides a personalized smile.",
            button: "Book an Appointment"
        },
        dentalSymptoms: {
            sectionTitle: "SYMPTOMS",
            title: "When to Visit Your Dentist",
            description: "Early diagnosis is crucial for your oral health. You should consult your dentist without delay if you notice any of these symptoms.",
            symptoms: [
                {
                    icon: "tooth-pain",
                    title: "Tooth Pain",
                    description: "Pain while eating or spontaneous tooth pain"
                },
                {
                    icon: "gum",
                    title: "Bleeding Gums",
                    description: "Bleeding while brushing or spontaneous gum bleeding"
                },
                {
                    icon: "cavity",
                    title: "Suspected Cavity",
                    description: "Black or brown spots visible on teeth"
                },
                {
                    icon: "bad-breath",
                    title: "Bad Breath",
                    description: "Persistent bad breath that cannot be eliminated"
                },
                {
                    icon: "sensitivity",
                    title: "Extreme Sensitivity",
                    description: "Sensitivity to cold or hot food and beverages"
                }
            ]
        },
        gallery: {
            sectionTitle: "GALLERY",
            title: "Before and After Treatment",
            description: "Some examples of successful treatments performed in our clinic. With our treatments planned specifically for each patient, we achieve natural and aesthetic results."
        },
        blogs: {
            sectionTitle: "BLOG",
            title: "News & Articles",
            description: "Stay updated with our latest blog posts and news, and get healthy tips & tricks for oral health.",
            viewAll: "View All",
            single: {
                getUpdates: "Sizi Arayalım",
                subscribe: {
                    placeholder: "Telefon numaranızı girin",
                    button: "Beni Ara"
                },
                categories: {
                    title: "Kategoriler"
                },
                category: "Kategori"
            },
            backToBlogs: "Back to Blogs",
            noBlogsFound: "No blogs found"
        },
        cookies: {
            title: "Cookie Notice",
            description: "This website uses cookies to provide you with the best experience. By continuing to use our site, you accept our cookie policy.",
            accept: "Accept",
            reject: "Reject",
            single: {
                category: "TECHNOLOGY",
                getUpdates: "Güncel Bilgileri Alın",
                subscribe: {
                    placeholder: "E-posta adresiniz",
                    button: "Abone Ol"
                },
                categories: {
                    title: "Kategoriler",
                    items: [
                        "Teknoloji",
                        "Kanal Tedavisi",
                        "Dişler",
                        "Beyazlatma",
                        "Protez"
                    ]
                },
                technology: {
                    title: "Diş Operasyonlarında Yeni Teknolojiler",
                    content: [
                        "Son yıllarda diş hekimliği alanında önemli teknolojik gelişmeler yaşanıyor ve bu gelişmeler sayesinde tedaviler daha verimli, hassas ve hasta dostu hale geliyor. Geleneksel diş tedavi yöntemlerini dönüştüren bu yenilikler, hasta bakım kalitesini önemli ölçüde artırıyor. İşte diş operasyonlarında kullanılan en yeni teknolojiler:",
                        {
                            subtitle: "1. İntraoral Tarayıcılar ve Dijital Ölçüler",
                            text: "Geleneksel diş ölçüleri çoğu zaman rahatsız edici olabilir ve bazen tam olarak istenilen sonucu vermez. İntraoral tarayıcılar bu sorunu ortadan kaldırarak, ağız içinin ayrıntılı dijital görüntülerini yakalar. Bu tarayıcılar, ışık kaynakları ve sensörler kullanarak dişlerin ve yumuşak dokuların 3D modellerini oluşturur. Böylece diş protezleri daha hassas bir şekilde tasarlanabilir ve hastalar için daha konforlu hale gelir."
                        },
                        // ... diğer içerik bölümleri
                    ]
                }
            },
            cards: [
                {
                    category: "TEKNOLOJİ",
                    title: "Yeni Teknoloji ile Dental Operasyonlar",
                    description: "Modern diş hekimliğinde kullanılan...",
                    date: {
                        day: "23",
                        month: "Jan"
                    }
                },
                {
                    category: "DİŞ SAĞLIĞI",
                    title: "Regular Dental Care Make Your Smile Brighter",
                    description: "The importance of regular dental care and effective dental care methods you can apply at home.",
                    date: {
                        day: "23",
                        month: "Jan"
                    }
                },
                {
                    category: "HYGIENE",
                    title: "Dental Hygiene for All Age to Make Smile",
                    description: "Special dental care and hygiene recommendations for all age groups from children to adults.",
                    date: {
                        day: "23",
                        month: "Jan"
                    }
                }
            ]
        },
        hero: {
            title: "Trust Your Smile to Experts",
            description: "With our modern dentistry techniques and expert staff, we create personalized treatment plans and design your smile. We provide service with the latest technology in our comfortable and sterile environment.",
            appointmentButton: "Book Appointment",
            workingHoursTitle: "Working Hours",
            workingHours: "Monday - Saturday: 09:00 - 23:00",
            doctorTitle: "Dentist"
        },
        pagination: {
            previous: "Previous",
            next: "Next"
        },
        treatmentSidebar: {
            callUs: "Sizi Arayalım",
            callDescription: "Would you like to talk about your dental problem?",
            phonePlaceholder: "Your Phone Number",
            callButton: "Call Me",
            sent: "✓ Sent",
            invalidPhone: "Please enter your phone number using only numbers.",
            successMessage: "Your request has been received! We will call you as soon as possible.",
            appointmentButton: "Book Appointment"
        }
    }
}; 